module.exports = __webpack_public_path__ + "static/media/ro.ad1fa0fa.svg";